module.exports = __webpack_public_path__ + "static/Bootstrap_Balloon-7f4c7482a01a861d08c959d70efc84b0.png";